import { cnpjMask, phoneMask } from '../../utilities/masks';
import { Tooltip as TooltipMaterial } from '@mui/material';
import { usePartnerContext } from "../../contexts/partner.context";

export interface IDashboardHeaderProps {
    title: any,
    description: any
}

export const DashboardHeader: React.FC<IDashboardHeaderProps> = (props: IDashboardHeaderProps) => {

    const { partner, showDefinedPartner } = usePartnerContext();

    return (
        <div className="dashboard-header">
            <div className='title'>
                <h4 className="dashboard-title">{props.title}</h4>
                <div className="dashboard-reserved ">{props.description}</div>
            </div>
            <TooltipMaterial title="Empresas do grupo">
                <div className="dashboard-corporation isClickable" onClick={() => showDefinedPartner(true) } >
                    {partner && partner.company && <div>
                        <div><strong>{partner.company.fantasy}</strong>{' - '}{cnpjMask(partner.company.registrationPj)}{' - '}{phoneMask(partner.company.telephone)}</div>
                    </div>}  
                </div>
            </TooltipMaterial>
        </div>
    )
}

export default DashboardHeader;
